module.exports = __webpack_public_path__ + "static/media/NUEVO_LOGO.629c7e58.svg";